// extracted by mini-css-extract-plugin
module.exports = {"Tooltip":"Tooltip__7jwri","Tooltip__overlay":"Tooltip__overlay__2zX2g","Tooltip__close":"Tooltip__close__2UEfp","Tooltip__pullCenter":"Tooltip__pullCenter__1CawA"};